import { createContext } from 'react'

export const appContext = createContext({})

export const AppContextProvider = appContext.Provider
